function verify_age(answer) {
  if (answer === 'YES') {
    document.getElementById('prompt-background').remove();
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 horas a partir del tiempo actual
    localStorage.setItem('ageVerified', JSON.stringify({ value: 'true', expires: expirationTime }));
    document.body.style.overflow = 'scroll';
  }
}

const _currentTime = new Date().getTime();
const ageVerified = JSON.parse(localStorage.getItem('ageVerified'));

if (ageVerified && ageVerified.value === 'true') {
  if (_currentTime >= ageVerified.expires) {
    localStorage.removeItem('ageVerified');
    if (document.getElementById('prompt-background')) {
      document.getElementById('prompt-background').style.display = 'block';
    }
    document.body.style.overflow = 'hidden';
  } else {
    document.getElementById('prompt-background').remove();
  }
} else {
  localStorage.removeItem('ageVerified');
  if (document.getElementById('prompt-background')) {
    document.getElementById('prompt-background').style.display = 'block';
  }
  document.body.style.overflow = 'hidden';
}
